<template>
    <div>
        <ValidationObserver ref="personalInfoFormValidate">
            <h6>{{ $t('identity_information') }}</h6>
            <div class="border p-4 rounded-sm mb-3">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('national_id')">
                            <ValidationProvider name="national_id" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.national_id"
                                              :state="errors[0] ? false : null" :disabled="true" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('name')">
                            <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.name"
                                              :state="errors[0] ? false : null"
                                              :disabled="true"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('surname')">
                            <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.surname"
                                              :state="errors[0] ? false : null"
                                              :disabled="true"/>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('birthdate')">
                                <select-date v-model="localFormData.birthdate" :validationError="errors[0]" :disabled="true" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
<!--                    <b-col cols="12" md="6" lg="4">-->
<!--                        <ValidationProvider name="gender" rules="required" v-slot="{ errors }">-->
<!--                            <b-form-group :label="$t('gender')">-->
<!--                                <gender-selectbox v-model="localFormData.gender"-->
<!--                                                  :disabled="isReadOnly"-->
<!--                                                  :validateError="errors[0]" />-->
<!--                            </b-form-group>-->
<!--                        </ValidationProvider>-->
<!--                    </b-col>-->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('gsm_no')">
                            <ValidationProvider name="mobile_tel" rules="required" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.phone"
                                              v-mask="'5## ### ## ##'"
                                              :disabled="isReadOnly"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('email')">
                            <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.email"
                                              :disabled="isReadOnly"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="city" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('city')">
                                <city-selectbox v-model="localFormData.city_id"
                                                :disabled="isReadOnly"
                                                :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="district" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('district')">
                                <district-outline-selectbox v-model="localFormData.district_id"
                                                            :city_id="localFormData.city_id"
                                                            :disabled="isReadOnly"
                                                            :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <ValidationProvider name="address" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('address')">
                                <b-form-textarea v-model="localFormData.address" rows="3"
                                                 :disabled="isReadOnly"
                                                 :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3" v-if="!isReadOnly">
                <processing-button :processing="loading" variant="primary"
                                   :label="$t('save_and_go').toUpper()" @click="save"/>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import GenderSelectbox from '@/components/interactive-fields/GenderSelectbox'
import SelectDate from '@/components/interactive-fields/SelectDate'
import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
import ProcessingButton from '@/components/elements/ProcessingButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import BisepService from "@/services/BisepService"

export default {
    name: "PersonalInfoTab",
    components: {
        GenderSelectbox,
        SelectDate,
        CitySelectbox,
        DistrictOutlineSelectbox,
        ProcessingButton,
        ValidationObserver,
        ValidationProvider
    },
    props: {
        footerInfo: {
            type: String,
            default: ''
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            localFormData:{},
            loading: false
        }
    },
    mounted() {
        this.loadFormData()
    },
    methods: {
        loadFormData() {
            const data = this.getWithExpiry('bisep_app_data', true)
            if (data) {
                this.localFormData = { ...data }
            }
        },
        async save() {
            const isValid = await this.$refs.personalInfoFormValidate.validate();
            if (isValid) {
                this.loading = true
                const pin = this.$store.getters['bisepApplication/getPin']
                const payload = {
                    ...this.localFormData,
                    national_id: this.localFormData.national_id,
                    pin: pin,
                    city_id: this.localFormData.city_id,
                    district_id: this.localFormData.district_id,
                    phone: this.localFormData.phone ? this.localFormData.phone.replace(/[^\d]/g, '') : ''
                }

                BisepService.updatePersonalInfo(payload).then(response => {
                    const updatedData = response.data.data
                    this.$store.commit('bisepApplication/setData', { data: updatedData })
                    this.$toast.success(this.$t('successfully_saved'))
                    this.$emit('success')
                }).catch(e => {
                    this.showErrors(e, this.$refs.personalInfoFormValidate)
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    },
}
</script>
